import React from 'react';
import cn from 'classnames';
import { prefix, bsClass, splitBsProps } from './utils/bootstrapUtils';
import { PanelContext } from '../Panel/PanelContext';
class PanelFooter extends React.Component {
  render() {
    const {
      children,
      className
    } = this.props;
    const {
      bsClass: _bsClass
    } = this.context || {};
    const [bsProps, elementProps] = splitBsProps(this.props);
    bsProps.bsClass = _bsClass || bsProps.bsClass;
    return /*#__PURE__*/React.createElement("div", Object.assign({}, elementProps, {
      className: cn(className, prefix(bsProps, 'footer'))
    }), children);
  }
}
PanelFooter.contextType = PanelContext;
export default bsClass('panel', PanelFooter);